import { useEffect, useState } from "react";

const ScrollButton = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div>
      {showScrollButton && (
        <button
          onClick={scrollToTop}
          className="btn btn-primary rounded-circle"
          style={{
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            zIndex: 1000,
            width: '40px',
            height: '40px',
            padding: 0
          }}
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default ScrollButton;